import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { useTour } from "@reactour/tour";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import mm from "../../images/logo.png";
import gcal from "../../images/google_calendar.png";
import mcal from "../../images/microsoft_calendar.png";
import { theme } from "../../utils/theme";
import { BiPlus, BiCrown } from "react-icons/bi";
import {
  getCalendarVerificationLinkMS,
  getCalendarVerificationLink,
  setDefaultBotName,
} from "../../functions";

import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import { CircularProgress } from "@mui/material";
import Loader from "./../../components/Popups/Loader";
import CustomVocab from "./CustomVocab";
import { getCurrentUser, partialUpdateUser, fetchUserData } from "../../services/UserService"
import { languageOptions } from '../../config/Constants'
import { findIfPaidUserForCrown } from "../../services/CommonService"

const More = () => {
  const [participants, setParticipants] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(getCurrentUser());
  
  const { setIsOpen } = useTour();
  
  // const { appSettings } = useSelector((state) => state.appReducer);
  const [showCrown, setShowCrown] = useState(false);

  const [languagesArray, setLanguagesArray] = useState([]);
  
  const [data, setData] = useState("");
  const [name, setName] = useState("");
  const [botName, setBotName] = useState("");
  const dispatch = useDispatch();
  const { userData, uid } = useSelector((state) => state.authReducer);
  const auth = getAuth();
  const [imgSrc, setImgSrc] = useState("https://cdn-icons-png.flaticon.com/256/149/149071.png");
  const profileRef = useRef(null);
  const [language, setLanguage] = useState(
    userData?.defaultLanguage || "english"
  );
  const [calendarAuthLoading, setCalendarAuthLoading] = useState(false);
  const [calendarAuthLoadingMs, setCalendarAuthLoadingMs] = useState(false);
  const storage = getStorage();
  

  const uploadImage = async () => {
    const storageRef = ref(
      storage,
      `users/${currentUser.uid}/profile.png`
    );
    const uploadTask = uploadBytesResumable(
      storageRef,
      profileRef.current.files[0]
    );
    uploadTask.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          let user = getCurrentUser();
          partialUpdateUser(user.uid, { profile: url },
            (response) => {
              fetchUserData(dispatch).then(() => {
                toast.success("Image Uploaded!");
              });
            }
          )
        });
      }
    );
  };

  useEffect(() => {
    findIfPaidUserForCrown({ setShowCrown, userData });
  }, []);

  const setUserData = async () => {
    let user = getCurrentUser();
    await partialUpdateUser(user.uid, { name: name, defaultLanguage: language })
    toast.success("Changes Saved");
    import("../../redux/actions/authActions").then((actions) =>
      dispatch(
        actions.addUser({ ...userData, name: name, defaultLanguage: language })
      )
    );
  };

  useEffect(() => {
    setData(userData);
    if (userData?.name) setName(userData?.name);
    if (userData?.profile) setImgSrc(userData?.profile);
  }, [userData]);

  //
  //
  //---------appSettings code below------------
  //
  // useEffect(() => {
  //   // Fetch the appSettings from Firestore
  //   const fetchAppSettings = async () => {
  //     try {
  //       const userRef = doc(db, `users/${localStorage.getItem("@auth")}`); // Construct the reference to the user document
  //       const userSnapshot = await getDoc(userRef); // Retrieve the user document

  //       if (userSnapshot.exists()) {
  //         const userData = userSnapshot.data();
  //         const settings = userData.appSettings;
  //         setAvailableLanguages([settings.payment.language]);
  //         setLanguages(settings.payment.language);
  //         console.log("Lang: ", languages);
  //         console.log("Lang2: ", availableLanguages);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching appSettings:", error);
  //     }
  //   };

  //   fetchAppSettings();
  // }, []);
  //---------appSettings code above------------
  //
  // useEffect(() => {
  //   if (botName !== "") {
  //     setDefaultCalendarPreference({
  //       user_id: localStorage.getItem("@auth"),
  //       bot_name: botName + "'s bot",
  //     }).then(() => {
  //       console.log("BotName from UseEffect - ", botName);
  //       setDoc(
  //         doc(db, `users/${localStorage.getItem("@auth")}`),
  //         { defaultPreferenceSet: true },
  //         { merge: true }
  //       );
  //     });
  //   } else {
  //     setDefaultCalendarPreference({
  //       user_id: localStorage.getItem("@auth"),
  //       bot_name: "Meet Minute's Bot",
  //     }).then(() => {
  //       console.log("BotName from UseEffect - ", botName);
  //       setDoc(
  //         doc(db, `users/${localStorage.getItem("@auth")}`),
  //         { defaultPreferenceSet: true },
  //         { merge: true }
  //       );
  //     });
  //   }
  // }, [botName]);

  const fetchLanguages = async () => {
    const subscriptionData = userData?.subscription || {};
    if (userData) {
      const languagesArray = subscriptionData?.[Object.keys(subscriptionData)[0]]?.languages || [];
      return languagesArray;
    } else {
      console.error("User not found.");
      return [];
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const languages = await fetchLanguages();
      setLanguagesArray(languages);
    };

    fetchData();
  }, []);

  const handleBotNameChange = (botName) => {
    console.log("Botname from Function: ", botName);
    let user = getCurrentUser();
    if (botName !== "") {
      setDefaultBotName({
        user_id: localStorage.getItem("@auth"),
        bot_name: botName + "'s MeetMinutes",
      }).then(() => {
        console.log("BotName from Save Changes - ", botName);
        partialUpdateUser(user.uid, { botName: botName });
      });
    } else {
      setDefaultBotName({
        user_id: localStorage.getItem("@auth"),
        bot_name: "MeetMinutes",
      }).then(() => {
        console.log("BotName from Save Changes - ", botName);
        partialUpdateUser(user.uid, { botName: "MeetMinutes" });
      });
    }
  };

  return (
    <div className="w-full">
      <Loader isLoading={isLoading} />
      <div className="3xl:text-3xl text-2xl mb-[20px] font-medium">
        My Account
      </div>
      <div className="border-2 lg:w-[50%] rounded-2xl bg-[#F7F6F2] p-[20px]">
        <div className="mb-[20px] flex items-center justify-center">
          <div className="w-[150px] h-[150px] relative">
            <img
              src={imgSrc}
              className="rounded-full shadow-md"
              title="Upload New Image"
              alt=""
              style={{ width: "100%", height: "100%" }}
            />
            {showCrown && (
              <div className="bg-white p-[5px] rounded-full absolute top-0 right-0 shadow-md">
                <BiCrown
                  className="text-yellow-500 text-4xl"
                  // You can adjust the color, size, and other styles as needed
                />
              </div>
            )}
            <div className="bg-white p-[5px] rounded-full absolute bottom-0 right-0 shadow-md">
              <BiPlus
                onClick={() => {
                  profileRef.current.click();
                }}
                className="text-white rounded-full text-3xl cursor-pointer"
                style={{ backgroundColor: theme.color }}
              />
              <input
                ref={profileRef}
                onChange={(e) => {
                  setImgSrc(URL.createObjectURL(e.target.files[0]));
                  uploadImage();
                }}
                type="file"
                accept=".png, .jpeg, .jpg, .svg"
                className="hidden"
                name=""
              />
            </div>
          </div>
        </div>

        <div className="s2-step drop-shadow-lg mx-auto bg-white rounded-md px-[15px] py-[5px] my-[10px]">
          <div className=" text-[#07457F] 3xl:text-[20px] text-[16px] font-semibold ">
            Name
          </div>
          {/* <div className='3xl:text-[25px] text-[16px]'>{data?.name}</div> */}

          <input
            type="text"
            // defaultValue={data?.name}
            className="outline-none"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
        </div>
        <div className="drop-shadow-lg mx-auto bg-white rounded-md px-[15px] py-[5px] my-[10px] example">
          <div className="text-[#07457F]  3xl:text-[20px] text-[16px]  font-semibold ">
            Email
          </div>
          <div className="w-full hideScrollbar rounded-[5px] overflow-auto">
            {data?.email}
          </div>
        </div>

        <div className="s3-step my-[10px] flex justify-between items-center gap-[20px] flex-wrap">
          Default Meeting Language
          <div className="relative transition">
            <select
              value={language}
              onChange={(e) => {
                setLanguage(e.target.value);
              }}
              className="block appearance-none w-full transition bg-white border border-[#07457f] text-[#07457f] py-2 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            >
              {Object.entries(languageOptions).map(([value, optionText]) => (
                <option
                  key={value}
                  value={value}
                  disabled={!languagesArray.includes(value)}
                >
                  {optionText}
                </option>
              ))}
            </select>
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-[#07457f]">
              <svg className="fill-current h-4 w-4" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M6 8l4 4 4-4H6z" />
              </svg>
            </div>
          </div>
        </div>

        <div
          onClick={() => {
            console.log("Name: ", name);
            handleBotNameChange(name);

            setIsLoading(true);
            setUserData()
              .then(() => {
                setIsLoading(false);
              })
              .catch(() => {
                setIsLoading(false);
              });
          }}
          className="my-[10px] font-medium text-black rounded-md  p-[10px] text-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
        >
          Save Changes
        </div>
        <div className="s4-step">
          <div
            onClick={() => {
              setIsLoading(true);
              setCalendarAuthLoading(true);
              fetchUserData(dispatch);
              getCalendarVerificationLink({
                user_id: localStorage.getItem("@auth")
              })
              .then((res) => {
                window.open(res.auth_url);
              })
              .catch(() => {
                toast.error("Some error occured, please try later!");
              })
              .finally(() => {
                setIsLoading(false);
                setCalendarAuthLoading(false);
              });
            }}
            // style={{ backgroundColor: theme.color }}
            className="text-black rounded-md px-[15px] font-medium py-[10px] mb-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
          >
            {calendarAuthLoading ? (
              <CircularProgress
                style={{ color: "#07457F", width: "20px", height: "20px" }}
              />
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img className="w-[35px]" src={gcal} alt="Calendar" />
                <span style={{ marginLeft: "8px" }}>
                  Connect Google Calendar
                </span>
              </div>
            )}
          </div>

          <div
            onClick={() => {
              setCalendarAuthLoadingMs(true);
              fetchUserData(dispatch);
              getCalendarVerificationLinkMS({
                user_id: localStorage.getItem("@auth")
              })
              .then((res) => {
                // console.log(res);
                window.open(res.auth_url);
              })
              .catch(() => {
                toast.error("Some error occured, please try later!");
              })
              .finally(() => {
                setCalendarAuthLoadingMs(false);
              });
            }}
            // style={{ backgroundColor: theme.color }}
            className="text-black rounded-md px-[15px] font-medium py-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
          >
            {calendarAuthLoadingMs ? (
              <CircularProgress
                style={{ color: "#07457F", width: "20px", height: "20px" }}
              />
            ) : (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img className="w-[20px]" src={mcal} alt="Calendar" />
                <span style={{ marginLeft: "8px" }}>
                  Connect Microsoft Calendar
                </span>
              </div>
            )}
          </div>
        </div>
        <div
          onClick={() => {
            setIsLoading(true);
            sendPasswordResetEmail(auth, data.email)
              .then(() => {
                toast.success(`Mail sent to ${data.email}`);
                setIsLoading(false);
              })
              .catch(() => {
                setIsLoading(false);
              });
          }}
          // style={{ backgroundColor: theme.color }}
          className="s5-step text-black rounded-md px-[15px] my-[10px] font-medium py-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
        >
          Change Password
        </div>
        <div
          onClick={() => setIsOpen(true)}
          // style={{ backgroundColor: theme.color }}
          className="text-blck rounded-md px-[15px] my-[10px] font-medium py-[10px] flex items-center justify-center cursor-pointer border-2 border-[#07457F] hover:border-sky-500"
        >
          User Tour
        </div>
        <div className="my-6 border-b-2 border-gray-400"></div>
        <div>
          <CustomVocab
            languagesArray={languagesArray}
            languageOptions={languageOptions}
            userData={userData}
          />
        </div>
      </div>
    </div>
  );
};
export default More;
{
  /*

zip -r meet-minutes-master.zip meet-minutes-master 

*/
}
